"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M13.475 12c0 .812-.66 1.47-1.474 1.47A1.472 1.472 0 0110.527 12c0-.812.66-1.47 1.474-1.47s1.474.658 1.474 1.47z" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.4 12A7.84 7.84 0 0112 8.4a7.843 7.843 0 016.601 3.6 7.843 7.843 0 01-6.601 3.6A7.84 7.84 0 015.4 12zm4.126 0a2.47 2.47 0 002.475 2.467A2.471 2.471 0 0014.476 12 2.47 2.47 0 0012 9.533 2.47 2.47 0 009.526 12z" })), "Preview");
//# sourceMappingURL=Preview.js.map